// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import BrandingProvider from './providers/BrandingProvider';
import { BrowserRouter } from 'react-router-dom';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <BrandingProvider>
        <App />
      </BrandingProvider>
    </BrowserRouter>
  </React.StrictMode>
);
